export class LoginImage {
    _id: string;
    title: string;
    midias: any[];
}


// WEBPACK FOOTER //
// ./src/app/loginImage/loginimage.model.ts